// @flow

import window from 'window';
import Q from 'q';
import _ from 'lodash';

// import invariant from 'invariant';

import ko from 'rgs-knockout';
import vb from 'validation-builder';

import bytes from 'bytes';

import server from 'server';
import { default as server2, lkRoute } from 'server2';

import page from 'page-common';
import url from 'url';
import debugGlobals from 'debug-globals';

import { EventEmitter } from 'event-emitter';
import TraceKit from 'rgs-tracekit';
import { initNamespaceStorage } from "js-storage";

import { JSableMixin } from 'jsable';

import { ValidatableMixin } from 'validatable';
import { ObservableBusy } from 'observable-busy';

import { serverTime } from 'observable-server-time';
import { observableJSableMobilePhone } from 'observable-mobile-phone';

import { profile } from 'myrgs-auth-helpers-user';
import { esiaAuthWindow } from 'myrgs-auth-helpers-esia';

import { root as rootLogContext } from 'log-context';

import { Error, ignoreHandledErrors } from 'error';

import { temporaryFileInfoToFromJSExtend } from 'ko-extender-to-from-js-temporary-file-info';

import { RestIdentityDocument } from "calc-common";

import { ESIA_AUTH_STATUS } from './contracts/api-status';

// import fullRulesModalTemplate from '../templates/full-rules-modal.html';
// import fullRulesModalTemplate from '../templates/full-rules-modal.html';
/* eslint-disable max-len */
import stablePersonalDataMismatchTemplate from '../templates/notifications/stable-personal-data-mismatch.html';
import emailConfirmationSentTemplate from '../templates/notifications/email-confirmation-sent.html';
/* eslint-enable max-len */

import {
	fcmNames,
	fcmSubStatuses,
	PERSONAL_AGREEMENT_LINK,
	PERSONAL_DMS_AGREEMENT_LINK,
} from '../constants';
import {
	checkFcmAvailability,
	getPushSubResult,
} from './utils/firebase-utils';

import type { EventEmitterInterface } from 'event-emitter';
import type { JSableInterface } from 'jsable';
import type { ValidatableInterface } from 'validatable';
import type { LogContextInterface, StartDataGetter } from 'log-context';
import type { Observable, PureComputed, ObservableArray } from 'rgs-knockout';
import type { DocumentDictionaryItem } from 'calc-common';

export type ValidationMode = 'register'
	| 'registerJuridical'
	| 'login'
	| 'esia'
	| 'esiaBind'
	| 'resetPassword'
	| 'smsLoginSmsSending'
	| 'smsLogin';
type ValidationOptions = { mode: ValidationMode };

export type MyrgsFormModelParams = {
	disablePersonType: boolean,
	dmsRegistrationLinkVisible: boolean,
	prefilling: {
		PersonType?: 'Physical' | 'Juridical',
		Email?: string,
		Phone?: string,
	},
	logContext: LogContextInterface,
	event: {
		authSuccess?: () => void,
	},
	dictionaries: {
		identityDocumentTypes: Array<DocumentDictionaryItem>
	},
	context: {
		siteID: string,
		pageUrls: Object
	}
};

const INVALID_CODE_MSG = 'Неверный код';

class RegisterIdentityDocument extends RestIdentityDocument {
	_model: MyrgsRegisterFormModel;

	constructor (...args) {
		super(...args);

		delete this.IssueCountryID;
		delete this.IssueCountryName;

		const [ model ] = args;
		this._model = model;

		this.Type.extend({
			validation: vb.required(),
			validationLoggingName: 'Удостоверение личности страхователя',
		});

		this.singleSeriesNumberInput
			.extend({ notify: 'always' })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.physicalPersonLkIdentityDocumentValue(this.Type),
				]),
			});

		// What's this for? Prolly need to delete
		this.Value = ko.pureComputed(() => (
			this.singleSeriesNumberInput()
		))
			.extend({
				validationLoggingName: 'Серия и номер',
			})
			.extend({ toJS: true });

		this.Copy = ko.observable()
			.extend(temporaryFileInfoToFromJSExtend)
			.extend({
				validationLoggingName: 'Скан-копия ДУЛ',
			})
			.extend({
				validation: vb.all([
					vb.custom(v => {
						const allowedExtensions = [
							'pdf',
							'jpg',
							'jpeg',
							'bmp',
							'png',
							'tif',
							'gif',
						];

						const name = v && v.Name();

						if (!v || !name) {
							return true;
						}

						return _.some(allowedExtensions,
							ext => name.toLowerCase().endsWith('.' + ext));
					}, 'недопустимый формат файла (только картинки или PDF)'),
					vb.fileMaxSize(() => this._model.maxFileSize()),
					vb.fileUploadFulfilled(),
				]),
			});
	}
}

let Base = ValidatableMixin(JSableMixin(EventEmitter));

// HACK: WORKAROUND for https://github.com/facebook/flow/issues/3915
interface FakeFlowBase {
	constructor(): self,

	+validationArray: $PropertyType<ValidatableInterface, 'validationArray'>;
	validationGroup: $PropertyType<ValidatableInterface, 'validationGroup'>;

	on: $PropertyType<EventEmitterInterface, 'on'>;
	once: $PropertyType<EventEmitterInterface, 'once'>;
	emit: $PropertyType<EventEmitterInterface, 'emit'>;

	toJS: $PropertyType<JSableInterface, 'toJS'>;
	fromJS: $PropertyType<JSableInterface, 'fromJS'>;
	+_toJSOmit: $PropertyType<JSableInterface, 'fromJS'>;
}

Base = ((Base: any): Class<FakeFlowBase>);

class MyrgsRegisterFormModel extends Base {
	_params: MyrgsFormModelParams;

	_busy: ObservableBusy;

	_siteID: string;
	_pageUrls: Object;

	_logContext: LogContextInterface;
	_defaultStartDataGetters: StartDataGetter;
	_fullName: PureComputed<string>;

	rulesAccepted: Observable<boolean>;
	isPersonTypeJuridical: Observable<boolean>;
	maxFileSize: Observable<any>;
	documentTypes: ObservableArray<Array<DocumentDictionaryItem>>;

	PersonType: Observable<'Physical' | 'Juridical'>;
	UserHasPassword: Observable<null | boolean>;
	IdentityDocument: RegisterIdentityDocument;

	Email: Observable<string>;
	Phone: Observable<string>;
	FirstName: Observable<string>;
	LastName: Observable<string>;
	MiddleName: Observable<string>;
	BirthDay: Observable<string>;


	constructor (params: $Shape<MyrgsFormModelParams>) {
		super();

		this._params = params = _.defaultsDeep({}, params, {
			disablePersonType: false,
			dmsRegistrationLinkVisible: false,
			prefilling: {
				PersonType: 'Physical',
				Email: undefined,
			},
			event: {
				authSuccess: undefined,
			},
		});

		this._siteID = params.context.siteID;
		this._pageUrls = params.context.pageUrls;
		this._pdn = params.context.personalDataProcessingInfo;
		this._dmsPdn = params.context.dmsPersonalDataProcessingInfo;

		this._defaultStartDataGetters = () => ({
			UserProfileAuth: () => _.mapKeys(this.toSplunkJS(), (v, k) => _.get({
				Email: 'EmailAuth',
				PersonType: 'PersonTypeAuth',
			}, [k], k)),
		});

		this._logContext = params.logContext || rootLogContext;

		this._busy = new ObservableBusy;

		this.PersonType = ko.pureComputed({
			read: () => this.isPersonTypeJuridical() ? 'Juridical' : 'Physical',
			write: v => this.isPersonTypeJuridical('Juridical' === v),
		})
			.extend({ toFromJS: true });

		this.UserHasPassword = ko.map(ko.oneOf([null, true, false]), v => {
			if (this.isPersonTypeJuridical()) {
				return true;
			}
			return v;
		})
			.extend({ toFromJS: true })
			.extend({ notEqual: null });

		this.Email = ko.observable(this._params.prefilling.Email || '')
			.extend({ toFromJS: true })
			.extend({
				validationLoggingName: 'Ваш email',
			})
			.extend({
				required: true,
				email: true,
			});

		this.Phone = observableJSableMobilePhone(this._params.prefilling.Phone || '')
			.extend({
				validationLoggingName: 'Ваш номер мобильного телефона',
			})
			.extend({
				required: true,
				validation: vb.phone11Digits(),
			});

		const isPersonFullNameEntered = ko.pureComputed(() => {
			return Boolean(this.FirstName()) && Boolean(this.LastName());
		});

		this.FirstName = ko.observable('')
			.extend({
				validation: vb.all([
					vb.required(),
					vb.consecutiveCharRepetitionLimit(3),
					vb.lengthMin(1),
					vb.lengthMax(30),
					vb.if(
						() => this.IdentityDocument.Type.isDocumentForeignPassport(),
						vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
						vb.nameCyrillicWithSymbols(),
					),
					vb.if(
						() => isPersonFullNameEntered(),
						vb.extendedSameCharsetFullName(() => this._fullName()),
					),
				]),
			})
			.extend({
				validationLoggingName: 'Имя',
			})
			.extend({ toFromJS: true });

		this.LastName = ko.observable('')
			.extend({
				validation: vb.all([
					vb.required(),
					vb.consecutiveCharRepetitionLimit(3),
					vb.lengthMin(1),
					vb.lengthMax(30),
					vb.if(
						() => this.IdentityDocument.Type.isDocumentForeignPassport(),
						vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
						vb.nameCyrillicWithSymbols(),
					),
					vb.if(
						() => isPersonFullNameEntered(),
						vb.extendedSameCharsetFullName(() => this._fullName()),
					),
				]),
			})
			.extend({
				validationLoggingName: 'Фамилия',
			})
			.extend({ toFromJS: true });

		this.MiddleName = ko.observable('')
			.extend({
				validation: vb.all([
					vb.consecutiveCharRepetitionLimit(3),
					vb.lengthMin(1),
					vb.lengthMax(30),
					vb.if(
						() => this.IdentityDocument.Type.isDocumentForeignPassport(),
						vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
						vb.nameCyrillicWithSymbols(),
					),
					vb.if(
						() => isPersonFullNameEntered(),
						vb.extendedSameCharsetFullName(() => this._fullName()),
					),
				]),
			})
			.extend({
				validationLoggingName: 'Отчество',
			})
			.extend({ toFromJS: true });

		this.BirthDay = ko.observable()
			.extend({toFromJS: true})
			.extend({
				validation: vb.all([
					vb.momentMinAge({
						age: 18,
						from: serverTime(),
					}),
					vb.momentMaxAge({
						age: 130,
						from: serverTime(),
					}),
					vb.momentIsSameOrBefore(
						() => serverTime().startOf('day'),
					),
					vb.required(true, 'Введите дату рождения'),
					vb.momentIsValid(),
				]),
			})
			.extend({
				validationLoggingName: 'Дата рождения',
			});

		this._fullName = ko.pureComputed(() => {
			const [first, last, middle]
					  = [ this.FirstName(), this.LastName(), this.MiddleName() ];
			return (last || '')
				+ ' '
				+ (first || '')
				+ (middle ? ' ' + middle : '');
		});

		this.rulesAccepted = ko.observable(false)
			.extend({
				validationLoggingName: 'Достоверное согласие на передачу персональных данных',
			})
			.extend({
				equal: {
					params: true,
					message: 'подтвердите согласие',
				},
			});

		this.isPersonTypeJuridical = ko.observable(
			this._params.prefilling.PersonType === 'Juridical'
		);

		this.maxFileSize = ko.constant(bytes.parse('2mb'))
			.extend({
				repr: b => bytes.format(b),
			});

		this.IdentityDocument = new RegisterIdentityDocument(this);

		this.documentTypes = ko.observableArray(params.dictionaries.identityDocumentTypes);

		this.CaptchaKey = ko.observable();
		this.CaptchaValue = ko.observable().extend({ required: true });

		this.isCaptchaChecked = ko.observable();
	}

	_toJSOmit () {
		return super._toJSOmit(...arguments);
	}

	toSplunkJS () {
		return _.pick(this.toJS(), [
			'Email',
			'PersonType',
			'UserHasPassword',
			'FirstName',
			'LastName',
			'MiddleName',
			'BirthDay',
			'IdentityDocument.Value',
			'IdentityDocument.Type',
		]);
	}

	validationArray ({ mode }: ValidationOptions) {
		if (mode === 'esiaBind') {
			return [
				this.Email,
				this.Phone,
				this.BirthDay,
				...this.IdentityDocument.validationArray(),
				this.EmailVerificationCode,
			];
		}

		if (mode === 'registerJuridical') {
			return [
				this.Email,
				this.rulesAccepted,
			];
		}
		if (mode === 'register') {
			return [
				this.Email,
				this.Phone,
				this.FirstName,
				this.LastName,
				this.MiddleName,
				this.BirthDay,
				this.IdentityDocument.Series,
				this.IdentityDocument.Number,
				this.IdentityDocument.Type,
			];
		}

		return [];
	}
}

class MyrgsLoginOrRegisterFormModel extends MyrgsRegisterFormModel {

	Password: Observable<string>;

	constructor (...args: *) {
		super(...args);

		this.Password = ko.observable('')
			.extend({
				toFromJS: true,
			})
			.extend({
				validationLoggingName: 'Пароль',
			})
			.extend({
				required: true,
			});

		this.on('loginClick', this._loginClick.bind(this));
		this.on('registerPhysicalPersonClick', this._registerPhysicalPersonClick.bind(this));
		this.on('registerJuridicalPersonClick', this._registerJuridicalPersonClick.bind(this));
		this.on('resetPasswordClick', this._resetPasswordClick.bind(this));
		this.on('showFullRulesClick', this._showFullRulesClick.bind(this));
		this.on('showFullDmsRulesClick', this._showFullDmsRulesClick.bind(this));

		if (this._params.event.authSuccess) {
			this.on('authSuccess', this._params.event.authSuccess);
		}

		if (this._params.event.registrationMode) {
			this.on('registrationMode', this._params.event.registrationMode);
		}
	}

	_login (logContext: LogContextInterface = this._logContext) {
		const routePersonType = this._isJuridicalPersonType()
			? 'juridical'
			: 'physical';

		return server2.my.cmsapi
			.withLogContext(logContext)
			.post([ 'lk', 'auth', routePersonType ], {
				body: this.toAuthJS(),
			})
			.then(profile.update)
			.then(server.util.filter.authenticated)
			.then(() => {
				page.notifications.removeAll({
					tags: ['myrgs-auth-form'],
				});
			})
			.catch((e: Error) => {
				/* eslint-disable max-len */
				const handledErrors = {
					InvalidCredentials: 'Учетная запись не найдена. Убедитесь в правильности ваших данных или зарегистрируйтесь.',
					Blocked: 'Вход в личный кабинет заблокирован, так как превышен лимит неудачных попыток ввода пароля. Повторите вход позднее.',
					InvalidPersonType: 'Неверный тип личного кабинета',
					ProfileDeleted: 'ЛК удален. Войти в Личный Кабинет невозможно. Зарегистрируйте, пожалуйста, новый Личный Кабинет.',
				};
				const message = handledErrors[e.message];
				/* eslint-enable max-len */

				if (!message) {
					throw e;
				}

				page.notifications.push({
					tags: ['myrgs-auth-form'],
					css: { 'notification-danger': true },
					expire: 'error',
					message,
				});

				e.handled = {
					type: 'notification',
					message,
				};

				throw e;
			});
	}

	_resetPasswordClick () {
		// NOTE: reset validation errors of login form (e.g. empty password)
		this.validationGroup({ mode: 'login' }).showAllMessages(false);

		if (!this.validationGroup({ mode: 'resetPassword' }).guard()) {
			this._busy
				.add(this._resetPassword())
				.catch(ignoreHandledErrors)
				.done();
		}
	}

	_isJuridicalPersonType = () => this.PersonType() === 'Juridical';

	_resetPasswordServerRequest () {
		const routePersonType = this._isJuridicalPersonType()
			? lkRoute.juridical
			: lkRoute.physical;

		return server2.any.rest
			.post([
				lkRoute.prefix,
				lkRoute.profiles,
				routePersonType,
				lkRoute.resetPassword,
			], {
				body: this.toResetPasswordJS(),
			});
	}

	_registerServerRequest () {
		const routePersonType = this._isJuridicalPersonType()
			? lkRoute.juridical
			: lkRoute.physical;

		const captcha = {key: this.CaptchaKey(), value: this.CaptchaValue()};

		return server2.withCaptcha(captcha).any.rest.post(
			[ lkRoute.prefix, lkRoute.profiles, routePersonType, lkRoute.register ],
			{
				body: this._isJuridicalPersonType()
					? this.toRegisterJuridicalJS()
					: this.toRegisterPhysicalJS(),
			}
		);
	}

	_pushResetPasswordSuccessNotification = () => (
		page.notifications.push({
			css: { 'notification-success': true },
			expire: 'info',
			message: [
				'Проверьте почту. Мы отправили вам пароль.',
				'Если вы не видите письмо от нас, оно могло попасть в вашу папку Спам.',
			].join(' '),
		})
	);

	_pushRegisterSuccessNotification = () => (
		page.notifications.push({
			css: { 'notification-success': true },
			expire: 'info',
			message: [
				'Проверьте почту. Мы отправили вам пароль.',
				'Если вы не видите письмо от нас, оно могло попасть в вашу папку Спам.',
			].join(' '),
		})
	);

	_resetPassword () {
		return this._resetPasswordServerRequest()
			.then(server.util.filter.successStatus)
			.then(this._pushResetPasswordSuccessNotification.bind(this))
			.catch((e: Error) => {
				const message = this._getResetPasswordHandledErrors()[e.message];

				if (message) {
					page.notifications.push({
						css: { 'notification-danger': true },
						expire: 'error',
						message,
					});

					e.handled = {
						type: 'notification',
						message,
					};
				}

				throw e;
			});
	}

	_loginClick () {
		if (!this.validationGroup({ mode: 'login' }).guard()) {

			return this._busy
				.add(
					this._login(this._logContext)
						.tap(() => this.emit('authSuccess'))
				)
				.catch(ignoreHandledErrors)
				.done();
		}
	}

	_register = async () => {
		try {
			const registerResponse = await this._registerServerRequest();

			await server.util.filter.successStatus(registerResponse);

			this._pushRegisterSuccessNotification();

			return;
		} catch (e) {
			const status = e.message;

			if (status !== 'AlreadyExists') {
				const message = this._getRegisterHandledErrors()[e.message];

				if (message) {
					page.notifications.push({
						css: { 'notification-danger': true },
						expire: 'error',
						message,
					});
	
					e.handled = {
						type: 'notification',
						message,
					};
				}

				throw e;
			}

			// 'AlreadyExists' is kinda okay. Lets try to reset password then
		}

		await this._resetPassword();
	};

	_getRegisterHandledErrors = () => ({
		// on 'AlreadyExists' expected to call of password reseting
		InvalidPersonType:
		'Данная операция не предусмотрена.'
		+ 'Обратитесь, пожалуйста, в службу поддержки Сайта.',
	});

	_getResetPasswordHandledErrors = () => ({
		AlreadySent: 'Пароль уже был отправлен. Дождитесь получения.',
		InvalidPersonType: 'Данная операция не предусмотрена.'
		+ 'Обратитесь, пожалуйста, в службу поддержки Сайта.',
		NotFound:
			`Личного кабинета для указанного e-mail не существует. 
			Для того чтобы завести личный кабинет, 
			воспользуйтесь кнопкой "У меня еще нет пароля".`,
	});

	_registerPhysicalPersonClick () {
		if (this._busy.isBusy()) {
			return;
		}
		
		this.validationGroup({ mode: 'login' }).showAllMessages(false);
		if (!this.validationGroup({ mode: 'register' }).guard()) {
			this._busy
				.add(this._register())
				.catch(ignoreHandledErrors)
				.done();
		}
	}

	_registerJuridicalPersonClick () {
		if (this._busy.isBusy()) {
			return;
		}

		this.validationGroup({ mode: 'login' }).showAllMessages(false);
		
		if (!this.validationGroup({ mode: 'registerJuridical' }).guard()) {
			this._busy
				.add(this._register())
				.catch(ignoreHandledErrors)
				.done();
		}
	}

	_showFullRulesClick () {
		window.open(PERSONAL_AGREEMENT_LINK, '_blank');
		window.open(PERSONAL_AGREEMENT_LINK, '_blank');
	}

	_showFullDmsRulesClick () {
		window.open(PERSONAL_DMS_AGREEMENT_LINK, '_blank');
	}

	validationArray ({ mode }: ValidationOptions) {
		if (mode === 'login') {
			const validate = [ this.Email, this.Password, this.rulesAccepted ];
			if (this.UserHasPassword() === false) {
				validate.push(this.Phone);
			}
			return validate;
		}

		return super.validationArray(...arguments);
	}
}

class MyrgsLoginOrRegisterOrLoginThrougEsiaFormModel extends MyrgsLoginOrRegisterFormModel {
	EsiaLoginAvailable: Observable<boolean>;
	Mode: Observable<'Rgs' | 'Esia'>;

	constructor (...args: *) {
		super(...args);

		this.EsiaLoginAvailable = ko.pureComputed(() => {
			return this.PersonType() === 'Physical';
		});

		this.Mode = ko.oneOf(['Rgs', 'Esia']);

		this._esiaEmailForVerificationList = [];

		this.esiaEmailConfirmationRequired = ko.pureComputed(() => (
			this.Email() && _.includes(this._esiaEmailForVerificationList, this.Email())
		));

		this.EsiaNativeEmail = ko.observable();

		this.EsiaToken = ko.observable().extend({toFromJS: true});
		this.EmailVerificationCode = ko.observable()
			.extend({toJS: true})
			.extend({
				validation: vb.if(
					() => this.esiaEmailConfirmationRequired(),
					vb.all([
						vb.required(),
					])
				),
			});

		this.on('loginEsiaClick', this._loginEsiaClick.bind(this));
		this.on('bindEsiaProfileClick', this._bindEsiaProfileClick.bind(this));
		this.on(
			'sendEsiaEmailConfirmationClick',
			this._sendEsiaEmailConfirmationClick.bind(this)
		);

		this.EmailVerificationCode.subscribe(() => {
			if (this.EmailVerificationCode.error() === INVALID_CODE_MSG) {
				this.EmailVerificationCode.clearError();
			}
		});

		this.Email.subscribe(() => {
			const isEsiaMode = this.Mode() === 'Esia';
			if (isEsiaMode && this.EmailVerificationCode.error() === INVALID_CODE_MSG) {
				this.EmailVerificationCode.clearError();
			}
		});

		this._esiaBindingLogContext = null;

		this.myRgsUrl = url.format(url.parse(this._pageUrls.mr.home));

		debugGlobals.extend({
			myRgsAuthForm: this,
		});

		this._fcmStorage = initNamespaceStorage(
			fcmNames.storageSpace
		).localStorage;
	}

	_sendEsiaEmailConfirmation = () => {
		return server2.any.rest
			.withLogContext(this._esiaBindingLogContext)
			.post([
				lkRoute.prefix,
				lkRoute.profiles,
				lkRoute.physical,
				lkRoute.esia,
				lkRoute.emailVerification,
				lkRoute.send,
			], {
				body: { Email: this.Email() },
			})
			.then((response) => {
				const status = _.get(response, 'responseJSON.Status');

				if (status === 'Success') {
					page.notifications.push({
						tags: ['myrgs-auth-form'],
						css: { 'notification-success': true },
						template: {
							html: emailConfirmationSentTemplate(),
						},
					});
				} else if (status === 'AlreadySent') {
					page.notifications.push({
						tags: ['myrgs-auth-form'],
						css: { 'notification-success': true },
						message: 'Код подтверждения уже отправлен. Дождитесь получения.',
					});
				}

				return response;
			})
			.catch(e => {
				// Notification is missed somehow, thats why 'tryReport' is here
				console.error(e);
				TraceKit.tryReport(e, { quiet: false });

				e.handled = { type: 'notification' };

				throw e;
			});
	}

	_sendEsiaEmailConfirmationClick = () => {
		this._busy.add(this._sendEsiaEmailConfirmation())
			.done();
	}

	_loginEsiaClick () {
		this._askNotificationPermission();

		// NOTE: you have to call `esiaAuthWindow.open()` synchronously,
		// that's why we need to use the wierd deferred thing

		this.validationGroup({ mode: 'login' }).showAllMessages(false);

		const validationGroup = this.validationGroup({ mode: 'esia' });

		const loggingInWithEsiaLogContext = this._logContext.definedSubcontext();

		const esiaWindowPromise = validationGroup.isValid()
			? esiaAuthWindow.open(loggingInWithEsiaLogContext)
			: Q().then(() => validationGroup.throw({ form: { name: 'myrgsAuthForm' } }));

		this._busy.add(esiaWindowPromise)
			.then(result => {
				const { status, value: esiaResponse } = result;

				if (status === 'skipped') {
					const e = new Error('ESIA auth was skipped by user');
					e.handled = { type: 'silently' };
					throw e;
				}

				if (esiaResponse.error) {
					const e = new Error(
						esiaResponse.error_description || esiaResponse.error
					);
					e.name = esiaResponse.error;
					_.extend(e, { esiaResponse });
					throw e;
				}

				return result;
			})
			.then(({ value: esiaResponse }) => {
				const { state, code } = esiaResponse;

				const esiaAutoLogin = () => this._busy.add(
					server2.my.cmsapi
						.withLogContext(loggingInWithEsiaLogContext)
						.post(['lk', 'esia', 'login'], {
							body: { Code: code, State: state },
						})
						.then(async (res) => {
							return this._handleWebPushSubscription(res);
						})
						.then((response) => {
							const status = response.responseJSON.Status;

							if (status === ESIA_AUTH_STATUS.NOT_FOUND) {
								const data = response.responseJSON.Data;

								this.fromJS(data);
								this.EsiaNativeEmail(data.Email);
								
								throw new Error(status);
							}

							return response;
						})
						.then(server.util.filter.successStatus)
				);

				this._esiaBindingLogContext = loggingInWithEsiaLogContext;
				const bindEsiaUserToProfile = () => this._busy.add(
					server2.my.cmsapi
						.withLogContext(this._esiaBindingLogContext)
						.post(['lk', 'esia', 'bind'], {
							body: this.toEsiaBindJS(),
						})
					)
					.then(async (res) => {
						return this._handleWebPushSubscription(res);
					})
					.then(server.util.filter.successStatus)
					.catch(e => {
						const status = e.message;

						if (status === 'InvalidPersonType') {
							const message = 'Неверный тип личного кабинета';
							page.notifications.push({
								tags: ['myrgs-auth-form'],
								css: { 'notification-danger': true },
								expire: 'error',
								message,
							});
						} else if (status === 'StablePersonalDataMismatch') {
							page.notifications.push({
								tags: ['myrgs-auth-form'],
								css: { 'notification-danger': true },
								expire: 'error',
								template: {
									html: stablePersonalDataMismatchTemplate({
										myRgsUrl: this.myRgsUrl,
									}),
								},
							});
						} else if (status === 'EmailVerificationRequired') {
							this._esiaEmailForVerificationList.push(this.Email());
							this.Email.valueHasMutated();

							this._sendEsiaEmailConfirmation()
								.catch(e => {
									console.error(e);
									TraceKit.tryReport(e, { quiet: false });
								});

						} else if (status === 'InvalidEmailVerificationCode') {
							this.EmailVerificationCode.setError(INVALID_CODE_MSG);
						} else {
							console.error(e);
							TraceKit.tryReport(e, { quiet: false });
						}

						return this._initEsiaUserProfileBindingMode()
							.then(bindEsiaUserToProfile);
					});

				return esiaAutoLogin()
					.catch(e => {
						const status = e.message;

						if (status === ESIA_AUTH_STATUS.NOT_FOUND) {
							return this._initEsiaUserProfileBindingMode()
								.then(bindEsiaUserToProfile);
						}

						const handleErrorWithNotification = (notificationContent) => {
							const notification = _.defaults({
								tags: ['myrgs-auth-form'],
								css: { 'notification-danger': true },
								expire: 'error',
							}, notificationContent);

							page.notifications.push(notification);

							e.handled = { type: 'notification' };

							if (notificationContent.message) {
								e.handled.message = notificationContent.message;
							}
						};

						if (status === ESIA_AUTH_STATUS.NOT_TRUSTED_ESIA_USER) {
							handleErrorWithNotification({
								message: this.UserHasPassword()
									? (`Ваш профиль на сайте Госуслуг не подтвержден, авторизация 
									через ЕСИА недоступна. Для авторизации, введите ваш email 
									и пароль от сайта www.rgs.ru.`)
									: (`Ваш профиль на сайте Госуслуг не подтвержден, авторизация 
									через ЕСИА недоступна. Чтобы зарегистрироваться, укажите 
									свой email и получите временный пароль на email.`),
							});
						} else if (status === ESIA_AUTH_STATUS.INVALID_PERSON_TYPE) {
							handleErrorWithNotification({
								message: 'Неверный тип личного кабинета',
							});
						} else if (status === ESIA_AUTH_STATUS.STABLE_PERSONAL_DATA_MISSMATCH) {
							handleErrorWithNotification({
								template: {
									html: stablePersonalDataMismatchTemplate({
										myRgsUrl: this.myRgsUrl,
									}),
								},
							});
						}

						throw e;
					})
					.then(() => {
						return { status: 'authSuccess' };
					});
			})
			.tap(() => this._logContext.flush())
			.then(({ status }: any = {}) => { // TODO: no any
				if (status === 'authSuccess') {
					this.emit('authSuccess');
					return;
				}

				throw new Error(status);
			})
			.catch(ignoreHandledErrors)
			.done();
	}

	_initEsiaUserProfileBindingMode () {
		return Q.Promise(resolve => {
			this.Mode('Esia');
			this.once(
				'_esiaBindingStartTrigger',
				() => resolve({ status: '_esiaBindingStart' })
			);
		});
	}

	_bindEsiaProfileClick = () => {
		this.validationGroup({ mode: 'login' }).showAllMessages(false);
		if (this.validationGroup({ mode: 'esiaBind' }).guard()) {
			return;
		}

		this.emit('_esiaBindingStartTrigger');
	}

	validationArray ({ mode }: ValidationOptions) {
		if (mode === 'esia') {
			return [ this.rulesAccepted ];
		}

		if (mode === 'resetPassword') {
			return [
				this.rulesAccepted,
				this.Email,
			];
		}

		return super.validationArray(...arguments);
	}

	toEsiaBindJS = () => {
		return _.pick(this.toJS(), [
			'Phone',
			'IdentityDocument.Series',
			'IdentityDocument.Number',
			'IdentityDocument.Type',
			'EmailVerificationCode',
			'EsiaToken',
			'Email',
		]);
	}

	toAuthJS = () => {
		return _.pick(this.toJS(), [
			'Email',
			'Password',
		]);
	}

	toResetPasswordJS = () => {
		return _.pick(this.toJS(), [
			'Email',
		]);
	}

	toRegisterJuridicalJS = () => {
		return _.pick(this.toJS(), [
			'Email',
		]);
	}

	toRegisterPhysicalJS = () => {
		return _.pick(this.toJS(), [
			'FirstName',
			'MiddleName',
			'LastName',
			'Email',
			'BirthDay',
			'IdentityDocument.Type',
			'IdentityDocument.Series',
			'IdentityDocument.Number',
			'Phone',
		]);
	}

	_askNotificationPermission = async () => {
		try {
			const isAvailable = checkFcmAvailability();

			if (isAvailable) {
				await window.Notification.requestPermission();
			}
		} catch (error) {
			error.handled = true;
		}
	}

	_handleWebPushSubscription = async (data) => {
		try {
			const pushSubStatus = this._fcmStorage.get(fcmNames.subscriptionState);

			if (pushSubStatus === fcmSubStatuses.subscription) {
				return data;
			}

			const notificationsAvailable = checkFcmAvailability();
			if (!notificationsAvailable) {
				return data;
			}

			const permissionResult = window.Notification.permission;
			if (permissionResult === fcmSubStatuses.permission) {
				const subscriptionResult = await getPushSubResult();

				if (subscriptionResult) {
					this._fcmStorage.set(fcmNames.subscriptionState, subscriptionResult);
				}
			}
			return data;
		} catch (error) {
			error.handled = true;
			this._fcmStorage.set(fcmNames.subscriptionState, "");
			return data;
		}
	}
}

export default MyrgsLoginOrRegisterOrLoginThrougEsiaFormModel;
